import 'core-js/stable';

/** Proxy: IE >= 9, Firefox <= 17, Chrome <= 48, 6 >= Safari >= 9.1, iOS Safari <= 9.3 */
import 'proxy-polyfill';

/** Fetch: IE >= 10, Edge <= 13, Firefox <= 38, Chrome <= 41, 6.1 >= Safari <= 10, iOS Safari <= 10.2 */
import 'whatwg-fetch';

/** IntersectionObserver: IE >= 7, Edge <= 15, Firefox <= 54, Chrome <= 57, 6 <= Safari <= 12, iOS Safari <= 12.1  */
import 'intersection-observer';

/** AbortController: IE = 11, Edge <= 15, Firefox <= 56, Chrome <= 65, Safari <= 12, iOS Safari <= 11.2 */
/** для IE11 использует пакет выше whatwg-fetch */
import 'abortcontroller-polyfill';

/** Smooth Scroll: IE >= 9, 12 >= Edge >= 18, Firefox <= 35, Chrome <= 60, Safari >= 6  */
// https://caniuse.com/#search=Scroll-behavior
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

/** Requirements for Intl.NumberFormat, Intl.DateFormat */
import '@formatjs/intl-getcanonicallocales/polyfill';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/ru';


/** Intl.NumberFormat
 * https://caniuse.com/?search=Intl.NumberFormat
*/

import '@formatjs/intl-numberformat/polyfill';
import '@formatjs/intl-numberformat/locale-data/ru';

/** Intl.DateTimeFormat
 * https://caniuse.com/?search=Intl.DateTimeFormat
 */
import '@formatjs/intl-datetimeformat/polyfill';
import '@formatjs/intl-datetimeformat/locale-data/ru';
import '@formatjs/intl-datetimeformat/add-all-tz';
